import { useQuery } from "@tanstack/react-query";

import type { AgencySubscription } from "common/types";

import { get } from "../helpers/HTTP";

interface EstimateRenewal {
  nextBillingAt: number;
  amountDue: number;
  pricePerItem: number;
  basePrice: number;
}

async function workspaceEstimateRenewalRequest(): Promise<EstimateRenewal> {
  const { estimate } = await get(`subscriptions/estimates/renew`);
  const {
    subscription_estimate: subscriptionEstimate,
    invoice_estimate: invoiceEstimate,
  } = estimate;

  return {
    nextBillingAt: subscriptionEstimate.next_billing_at,
    amountDue: invoiceEstimate.amount_due,
    pricePerItem: invoiceEstimate.line_items.find(
      ({ pricing_model }: { pricing_model: string }) =>
        pricing_model === "per_unit",
    ).unit_amount,
    basePrice: invoiceEstimate.line_items.find(
      ({ pricing_model }: { pricing_model: string }) =>
        pricing_model === "flat_fee",
    ).unit_amount,
  };
}

export default function useCustomerEstimateRenewal(
  subscription: AgencySubscription | undefined,
) {
  const { data: estimateRenewal, isLoading: isLoadingEstimateRenewal } =
    useQuery({
      queryKey: ["estimateRenewal"],
      queryFn: () => workspaceEstimateRenewalRequest(),
      refetchOnMount: false,
      enabled:
        !!subscription &&
        subscription.status !== "cancelled" &&
        subscription.status !== "non_renewing",
    });

  return {
    estimateRenewal,
    isLoadingEstimateRenewal,
  };
}
